import {
  addToJobQueue,
  clearJobQueue,
  setActionRequired,
} from "slices/app/appSlice";
import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import {
  fetchCategories,
  fetchDocument,
} from "slices/dictionarySearch/actions/categories";

export const refreshView = (isFolderLevel) => async (dispatch, getState) => {
  dispatch(setActionRequired({}));
  dispatch(addToJobQueue("genericJob"));
  const by = getState().dictionarySearch.config.folderBy;
  await localhost
    .post(`/docs/dictionarySearch/folder/refreshStats`, null, {
      params: { folderId: getState().dictionarySearch.config.folderId },
    })
    .then(async () => {
      if (isFolderLevel) {
        dispatch(fetchCategories(by));
      } else {
        dispatch(fetchDocument());
      }
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
      dispatch(clearJobQueue());
    });
};
